<template>
  <input type="checkbox" v-bind:disabled="disabled === true" v-bind:checked="checked === true" class="margin-10" />
</template>

<style lang="scss">
@import "checkboxComponent.scss";
</style>

<script type="text/javascript">
import Vue from "vue";

export default Vue.extend({
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },

  methods: {}
});
</script>
